import { fonts, fontSizes } from './variables';

export const commonFontSet = `
  font-family: ${fonts.poppins};
  font-size: ${fontSizes.md};
  font-weight:500;
`;
